import { useCallback, useEffect, useState } from 'react';
import { API, STATISTICS_UNLOCK_PRODUCT_ID } from './components/partials/profileHelpers';

export const PULINA_CREDIT_PURCHASES_CHANGED = 'pulina-credit-purchases-changed';

/**
 * True when user has quantity &gt; 0 in user_credit_purchases for productId.
 * productId null/empty: no gate (unlocked true, not loading).
 * userId null: treated as not purchased (unlocked false).
 */
export function useCreditProductUnlocked(userId, productId) {
  const pid = productId && String(productId).trim() ? String(productId).trim() : null;
  const [loading, setLoading] = useState(!!(userId && pid));
  const [unlocked, setUnlocked] = useState(false);

  const refetch = useCallback(() => {
    if (!userId || !pid) return;
    const userIdStr = String(userId).replace(/n$/, '');
    setLoading(true);
    fetch(
      `${API}/api/users/${encodeURIComponent(userIdStr)}/credit-purchases/${encodeURIComponent(pid)}`
    )
      .then((r) => (r.ok ? r.json() : { quantity: 0 }))
      .then((d) => setUnlocked((d.quantity ?? 0) > 0))
      .catch(() => setUnlocked(false))
      .finally(() => setLoading(false));
  }, [userId, pid]);

  useEffect(() => {
    if (!pid) {
      setLoading(false);
      setUnlocked(true);
      return undefined;
    }
    if (!userId) {
      setLoading(false);
      setUnlocked(false);
      return undefined;
    }
    refetch();
    const onChange = () => refetch();
    if (typeof window === 'undefined') return undefined;
    window.addEventListener(PULINA_CREDIT_PURCHASES_CHANGED, onChange);
    return () => window.removeEventListener(PULINA_CREDIT_PURCHASES_CHANGED, onChange);
  }, [userId, pid, refetch]);

  return { loading, unlocked, refetch };
}

/** True when user has a row in user_credit_purchases for UNLOCK: Statistics. */
export function useStatisticsUnlock(userId) {
  return useCreditProductUnlocked(userId, STATISTICS_UNLOCK_PRODUCT_ID);
}
